import { Button } from 'localmed-core';
import React from 'react';
import style from './ProviderCardFooter.scss';

export default function ProviderCardFooter({ providerUrl }) {
  return (
    <div className={style['provider-card-footer']} data-qa="provider-card__view-openings">
      <Button to={providerUrl} tier="alert" size="sm">
        View All Openings
      </Button>
    </div>
  );
}
